module.exports = __webpack_public_path__ + "img/arctic-assault.405b3796.jpg";